import { wwtMemo } from '@wwt/custom/wwt'
import { useShallow } from 'zustand/react/shallow'

import { useModalManager } from '../model/useModalManager.ts'
import { RenderModal } from './RenderModal.tsx'

/**
 * Manager for render modals
 *
 * @author Ivan Shchedrovskyi
 */
export const ModalManager = wwtMemo(() => {
	const modal = useModalManager(useShallow(state => state.modals[0]))
	const closeModal = useModalManager.use.closeModal()

	if (modal === undefined) {
		return null
	}

	return (
		<RenderModal
			modal={modal}
			closeModal={closeModal}
		/>
	)
})
